import styled from 'styled-components'
import { colors, media, Link } from 'styles'

const StyledSiteLogo = styled(Link)`
  max-width: 100%;
  overflow: hidden;
  text-decoration: none;

  .text {
    margin: 0;
    font-style: italic;
    font-weight: 700;
    font-size: 3.2rem;
    color: ${colors.mainInverted};
  }

  sup {
    font-weight: 300;
  }
  img {
    width: 100%;
    max-width: 30rem;
    object-fit: contain;
  }

  @media (max-width: 120em) {
    .text {
      font-size: 2.6rem;
    }
  }
  ${media.phone`
    img {
      max-width: 20rem;
    }
  `}
`

export default StyledSiteLogo
